function truncateText(value, length, dots = false) {
  return `${value.slice(0, length)}${dots ? "..." : ""}`;
}

export default truncateText;
